import { Component, Input, NgModule, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShareDialogComponent } from '@modal/share-dialog/share-dialog.component';
import { Entity } from '@model/entities/entity';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.scss'],
})
export class ShareButtonComponent implements OnInit {
  @Input() public hideTextMobile: boolean = false;
  @Input() public entity: Entity;

  constructor(private MatDialog: MatDialog) {}

  ngOnInit() {}

  public click() {
    this.MatDialog.open(ShareDialogComponent, {
      data: {
        entity: this.entity,
      },
      disableClose: false,
      panelClass: ShareDialogComponent.cssClass,
    });
  }
}

@NgModule({
  declarations: [ShareButtonComponent],
  imports: [SharedModule],
  exports: [ShareButtonComponent, SharedModule],
})
export class ShareButtonComponentModule {}
